import setting from "@/setting.js"

export default {
  namespaced: true,
  state: {
    header: [], //当前顶部栏
    fullAside: [], //所有侧边栏
    aside: [], //当前侧边栏
    asideCollapse: setting.menu.asideCollapse //侧边栏收缩
  },
  actions: {
    //设置侧边栏状态
    asideCollapseSet({ state, dispatch }, collapse) {
      return new Promise(async resolve => {
        state.asideCollapse = collapse
        await dispatch(
          "d2admin/db/set",
          {
            dbName: "sys",
            path: "menu.asideCollapse",
            value: state.asideCollapse,
            user: true
          },
          { root: true }
        )
        resolve()
      })
    },
    //读取侧边栏状态
    asideCollapseLoad({ state, dispatch }) {
      return new Promise(async resolve => {
        state.asideCollapse = await dispatch(
          "d2admin/db/get",
          {
            dbName: "sys",
            path: "menu.asideCollapse",
            defaultValue: setting.menu.asideCollapse,
            user: true
          },
          { root: true }
        )
        resolve()
      })
    },
    //切换侧边栏状态
    asideCollapseToggle({ state, dispatch }) {
      return new Promise(async resolve => {
        state.asideCollapse = !state.asideCollapse
        await dispatch(
          "d2admin/db/set",
          {
            dbName: "sys",
            path: "menu.asideCollapse",
            value: state.asideCollapse,
            user: true
          },
          { root: true }
        )
        resolve()
      })
    }
  },
  mutations: {
    headerSet(state, menu) {
      state.header = menu
    },
    asideSet(state, menu) {
      state.aside = menu
    },
    fullAsideSet(state, menu) {
      state.fullAside = menu
      state.aside = menu
    }
  }
}
